import React from "react";
import solution from "../assets/articale/Fat woman on treadmill.png";
import GoodTick from "../assets/articale/good-tick.webp";




const NaturalSolution = () => {
  return (
    <div>
      <div className="relative w-full mb-6">
        <img
          src={solution}
          alt="Fat woman on treadmill"
          className="w-full rounded-3xl border border-gray-100"
          draggable="false"
        />
      </div>
      <div className="space-y-4 text-[#303030]">
        <p className="font-bold">{"So, What Can You Do Instead?"}</p>
        <p> To feel better and manage weight more effectively, you need to:</p>
        <div className="bg-[#e2f4f9] p-4"> 
          <div className="flex items-center gap-3 mb-4 last:mb-0"> 
            <div className="flex-shrink-0"> 
              <div className="flex-shrink-0"> 
                <img 
                  src={GoodTick}  
                  alt="" 
                  className="w-10 h-10"  
                  draggable="false"  
                />
              </div> 
            </div> 
            <p className="text-gray-800 font-bold">  
              {" Support gut balance "} 
            </p> 
          </div>  
          <div className="flex items-center gap-3 mb-4 last:mb-0">
            <div className="flex-shrink-0"> 
              <div className="flex-shrink-0"> 
                <img 
                  src={GoodTick} 
                  alt="" 
                  className="w-10 h-10"
                  draggable="false"
                />
              </div>  
            </div>
            <p className="text-gray-800 font-bold">
              {"Promote a healthier metabolism "} 
            </p>
          </div>
          <div className="flex items-center gap-3 mb-4 last:mb-0"> 
            <div className="flex-shrink-0"> 
              <div className="flex-shrink-0"> 
                <img 
                  src={GoodTick} 
                  alt="" 
                  className="w-10 h-10" 
                  draggable="false" 
                /> 
              </div> 
            </div> 
            <p className="text-gray-800 font-bold">  
              {"Encourage natural appetite regulation "}  
            </p>  
          </div>


        </div> 













        <p className="font-bold">{"But how?"}</p>
        <p>
        {"Many mainstream solutions focus on restriction or short-term fixes. Fortunately, there’s a way to support your gut and metabolism naturally, using science-backed ingredients—without harsh cleanses or medications."}
        </p>

      </div>
    </div>
  );
};

export default NaturalSolution;
